import { GKLayoutShellContext } from "@granular/gds";
import { useContext, useEffect } from "react";

/**
 * Itty bitty hook that when used will handle setting the shell title
 * in the GKLayoutShell.
 *
 * NOTE: The page context bar does this for you, but in cases where you
 * are not using the page context bar, you can use this hook to set
 * the shell title.
 *
 * TODO: Should this also set the document title via Helmet!?
 */
export const useSetShellTitle = (title: React.ReactNode): void => {
  const { setPageTitle } = useContext(GKLayoutShellContext);

  useEffect(() => {
    // This gets called to keep the GKLayoutShellContext in sync with the page title.
    // This is because on mobile we render the page title in the header instead of
    // in the context bar.
    setPageTitle(title);
  }, [title, setPageTitle]);
};
